import ReactMarkdown from 'react-markdown';
import zoneContent from '../zoneContent.json';

const ZoneDescription = ({ region }) => {
    if (!region) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                <p>Select a region to view its description</p>
            </div>
        );
    }

    const content = zoneContent[region];

    if (!content) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                <p>No description available for {region}</p>
            </div>
        );
    }

    return (
        <div style={{
            padding: '20px',
            lineHeight: '1.6',
            color: '#333'
        }}>
            <ReactMarkdown
                components={{
                    h1: ({ children }) => <h1 style={{ color: '#2c5282', marginBottom: '16px' }}>{children}</h1>,
                    h2: ({ children }) => <h2 style={{ color: '#2c5282', marginBottom: '14px' }}>{children}</h2>,
                    h3: ({ children }) => <h3 style={{ color: '#2c5282', marginBottom: '12px' }}>{children}</h3>,
                    p: ({ children }) => <p style={{ marginBottom: '12px' }}>{children}</p>,
                    strong: ({ children }) => <strong style={{ color: '#2c5282' }}>{children}</strong>,
                    table: ({ children }) => (
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            margin: '16px 0',
                            fontSize: '14px'
                        }}>
                            {children}
                        </table>
                    ),
                    th: ({ children }) => (
                        <th style={{
                            border: '1px solid #ddd',
                            padding: '8px',
                            backgroundColor: '#f8f9fa',
                            textAlign: 'left'
                        }}>
                            {children}
                        </th>
                    ),
                    td: ({ children }) => (
                        <td style={{
                            border: '1px solid #ddd',
                            padding: '8px'
                        }}>
                            {children}
                        </td>
                    ),
                    ul: ({ children }) => <ul style={{ marginBottom: '12px', paddingLeft: '24px' }}>{children}</ul>,
                    li: ({ children }) => <li style={{ marginBottom: '4px' }}>{children}</li>
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
};

export default ZoneDescription;
